import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { ListadoCuentas } from "@/lib/api";
import { avisoSinRepartir, tarjetaPrevision } from "@/lib/cuentas";

/** Lógica de Cuentas corrientes (sin JSX): una fila por fiduciante con su saldo de gastos. Admin y contador; sólo lectura. */
export function useCuentasCorrientesTab() {
  const { fid } = useContextoApp();
  const cuentas = useApiResource<ListadoCuentas>(`/api/fideicomisos/${fid}/cuentas`);
  return {
    cargando: !cuentas.data && cuentas.loading,
    errorCarga: !cuentas.data && cuentas.error ? cuentas.error.message : null,
    reintentar: cuentas.recargar,
    cuentas: cuentas.data ?? null,
    avisoSinRepartir: cuentas.data ? avisoSinRepartir(cuentas.data.totales) : null,
    prevision: cuentas.data ? tarjetaPrevision(cuentas.data.totales) : null,
  };
}
